import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=5817efab&scoped=true&"
import script from "./Perfil.vue?vue&type=script&lang=js&"
export * from "./Perfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5817efab",
  null
  
)

export default component.exports